import React from 'react'
import { TbRosetteNumber1 } from 'react-icons/tb'
import { FiUnlock, FiUsers } from 'react-icons/fi'
import { FiRefreshCcw } from 'react-icons/fi'
import { MdOutlineHistoryToggleOff } from 'react-icons/md'
import { TbGift } from 'react-icons/tb'
import { GrSubtractCircle } from 'react-icons/gr'
import { AiOutlinePlusCircle } from 'react-icons/ai'
import { BsPeopleFill, BsPersonAdd } from 'react-icons/bs'
import { PiUserBold } from 'react-icons/pi'

export const useStaticButtonsIcons = () => {

    const iconsHandler = ({ button }: { button: string }) => {
        if (button === "static_reset") { return <FiRefreshCcw size={25}></FiRefreshCcw> }
        if (button === "static_unblock") { return <FiUnlock size={25}></FiUnlock> }
        if (button === "static_bonus") { return <TbGift size={25} /> }
        if (button === "static_first") { return <TbRosetteNumber1 size={25}></TbRosetteNumber1> }
        if (button === "static_clone") { return <FiUsers size={25}></FiUsers> }
        if (button === "static_history") { return <MdOutlineHistoryToggleOff size={25}></MdOutlineHistoryToggleOff> }
        if (button === "static_subtract") { return <GrSubtractCircle size={25}></GrSubtractCircle > }
        if (button === "static_add") { return <AiOutlinePlusCircle size={25}></AiOutlinePlusCircle> }
        if (button === "static_newuser") { return <BsPersonAdd size={25}></BsPersonAdd> }
        if (button === "static_newplayerbyemail") { return <BsPeopleFill size={25}></BsPeopleFill> }
        if (button === "static_newplayer") { return <PiUserBold   size={25}></PiUserBold  > }
    }
 
    return { iconsHandler }

}
